import { useCallback } from 'react'
import './nav.css'

interface NavComponentProperties {
    viewChanged: any
}

const NavComponent = (props: NavComponentProperties) => {

    const linkClicked = useCallback((e: any) => {
        const view = e.currentTarget.dataset.view
        props.viewChanged(view)
    }, [props])

    return (
        <>
        <div className="nav">
        <div className="navHeader" title='Home' data-view='home' onClick={linkClicked} style={{cursor: 'pointer'}}>Mark S. Roberts</div>
        <div className="navButtons">
            <button className="navButton" data-view='home' id="home" onClick={linkClicked}>HOME</button>
            <button className="navButton" data-view='bio' id="bio" onClick={linkClicked}>BIOGRAPHY</button>
            <button className="navButton" data-view='books' id="books" onClick={linkClicked}>BOOKS</button>
        </div>
        </div>

        </>
    )
}

export default NavComponent